import { GTM_ID, SDK_ANALYTICS_BASE_URL } from 'gatsby-env-variables'

import isClient from '../../../utils/envs/isClient'

const getAnalyticsSDK = (url) => {
  if (!isClient()) return Promise.resolve(() => null)
  const script = document.createElement('script')
  return new Promise((resolve, reject) => {
    script.src = url
    script.async = true
    script.onload = () => resolve(window.SDKAnalytics)
    script.onerror = reject
    document.head.appendChild(script)
  })
}

export default getAnalyticsSDK(SDK_ANALYTICS_BASE_URL).then((SDKAnalytics) => {
  return SDKAnalytics({
    gtm: GTM_ID
  })
})
